// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ezY_","wrapper__loader":"_2U3mr","loader":"_10cGp","loader__svg":"_1zmS9","svg":"_1m-p5","rotate":"_2IIdR","svg__circle":"_22SVf","dash":"_238bj"};